import { ProductPack, ProductPackServiceI } from '../../../index.d'
import { Api } from '../../api'

export class ProductPackService implements ProductPackServiceI {
  async getProductPack(id: number): Promise<ProductPack> {
    if (typeof id !== 'number') throw new TypeError('id is wrong')

    const { data } = await Api.get<ProductPack>(`/api/product_packs/${id}`)

    return data
  }
}
